import React from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {routesForAuthenticatedOnly, routesForNotAuthenticatedOnly} from "../../../app/routes";
import useRoutePathMatch from "@jumbo/hooks/useRoutePathMatch";
import {removeToken, storeToken} from "./authHelpers";
import {config} from "../../../app/config/main";
import {AuthContext} from "@jumbo/components/JumboAuthProvider/JumboAuthContext";
import menus from 'app/layouts/shared/sidebars/Sidebar/menus';


const storedToken = localStorage.getItem("user");
let firstTimePageLoad = true;

const init = () => {
    let authUser = null;

    if (!config?.authSetting) {
        throw Error(`You are using oAuthProvider but you haven't setup authSetting inside /src/app/config/main.js's config object`);
    }

    if (storedToken) {
        storeToken(JSON.parse(storedToken)); // also sets axios header
    }

    return {
        authToken: storedToken ?? null,
        authUser: authUser,
        isLoading: false,
        menuObject:config.authSetting.menuObject,
        curr:config.authSetting.curr,
        fallbackPath: config.authSetting.fallbackPath,
    }
};

const authReducer = (state, action) => {
    switch (action.type) {
        case "set-auth-data":
            return {
                ...state,
                ...action.payload,
            };

        case "start-loading":
            return {
                ...state,
                isLoading: true,
            };

        case "stop-loading":
            return {
                ...state,
                isLoading: false,
            };
        case "set-menudata":
            return {
                ...state,
                menuObject: action.payload,
            };
        case "set-curr":
            return {
                ...state,
                curr: action.payload,
            };
        case "page-rights":
            return {
                ...state,
                rights: action.payload,
            };
    }
};

const JumboAuthProvider = ({children, ...restProps}) => {
    const [authOptions, setAuthOptions] = React.useReducer(authReducer, restProps, init);
    const [logout, setLogout] = React.useState(false);
    const navigate = useNavigate();
    const location =  useLocation();
    const isAuthenticatedRouteOnly = useRoutePathMatch(routesForAuthenticatedOnly,location?.pathname);
    const isNotAuthenticatedRouteOnly = useRoutePathMatch(routesForNotAuthenticatedOnly,location?.pathname,1);

//     React.useEffect(async() => {
// // console.log(authOptions.authUser);
    
//     },[authOptions.authUser])
    // console.log(firstTimePageLoad);
    React.useEffect(() => {
        if (logout) {
            removeToken();
            setAuthOptions({
                type: "set-auth-data",
                payload: {authToken: null,authUser: null, isLoading: false}
            });
            setAuthOptions({
                type: "set-menudata",
                payload: []
            });
            setLogout(false);
        }
    }, [logout]);
    const setAuthToken = React.useCallback(async (data) => {
        let uData = JSON.parse(data)
        setAuthOptions({type: "start-loading"});
        if (!data) {
            setLogout(true);
            return;
        }
        storeToken(uData);
        try {

            const authUser = await config?.authSetting?.getAuthUserService();
            if (authUser) {
                setAuthOptions({
                    type: "set-auth-data",
                    payload: {authToken: uData.token,authUser: authUser, isLoading: false}
                });
                return;
            }
            setLogout(true);

        } catch (error) {
            setLogout(true);
            console.error(error);
        }
    }, []);

    //todo: maybe in next version
    const setRedirectPath = React.useCallback((redirectPath) => {
        setAuthOptions({type: "set-redirect-path", payload: {redirectPath}});
    }, []);

    const setAuthData = React.useCallback((data) => {
        setAuthOptions({type: "set-auth-data", payload: data});
    }, []);

    const contextValue = React.useMemo(() => {

        return {
            ...authOptions,
            setAuthData,
            setRedirectPath,
            setAuthToken,
            setAuthOptions,
        }
        
    }, [authOptions]);
    React.useEffect(async() => {
        authOptions.authUser&&  await menus().then(async data =>{
            setAuthOptions({type:'set-menudata',payload:data})
            setAuthOptions({type:'set-curr',payload:{cd:'¥',Rate:data?.curr}})
        })
        if (!authOptions.authToken) {
            if (isAuthenticatedRouteOnly) {
                navigate(authOptions?.fallbackPath);
            }
        } else if (!authOptions.authUser) {
            setAuthToken(authOptions.authToken);
        } else if (await isNotAuthenticatedRouteOnly) {
            if (!firstTimePageLoad)
                navigate(config.authSetting.redirectNotAuthenticatedPath ?? "/");
            else
                firstTimePageLoad = false;
        }
        
    }, [authOptions.authUser]);
    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
};

export default JumboAuthProvider;